import {useGoogleReCaptcha} from 'react-google-recaptcha-v3'
import {Link} from "wouter"
import axios from "axios"
import {useState} from "react"
import appConfig from "../service/config"
import getErrorMessage from "../service/getError";
import Spinner from "./Spinner";

const Register = props => {
  const [responseMessage, setResponseMessage] = useState('')
  const [registered, setRegistered] = useState(false)
  const [loading, setLoading] = useState(false)
  const {executeRecaptcha} = useGoogleReCaptcha();

  const onSubmit = async e => {
    e.preventDefault()
    if (!executeRecaptcha) {
      setResponseMessage('Recaptcha has not been loaded. Please try later.')
      return
    }
    setLoading(true)
    const reCaptchaToken = await executeRecaptcha('submit')
    try {
      const response = await axios.post(appConfig.api_base + 'tipsters/', {
        "username": e.target.elements.username.value,
        "email": e.target.elements.email.value,
        "password": Math.random().toString(36).slice(-8),
        "newsletter": e.target.elements.newsletter.checked,
        "g-recaptcha-response": reCaptchaToken
      })
      await ajaxUserRegistration(response.data)
      setResponseMessage('')
      setLoading(false)
      setRegistered(true)
    } catch (error) {
      window.dispatchEvent(appConfig.showMessage(getErrorMessage(error)));
      setResponseMessage(getErrorMessage(error))
      setLoading(false)
    }
  }

  const ajaxUserRegistration = async data => {
    console.log(data)
    const formData = new FormData()
    formData.append('action', 'mtwprru')
    formData.append('username', data.username)
    formData.append('email', data.email)
    formData.append('id', data._id)
    formData.append('t', data.t)

    const response = await axios.post(appConfig.ajax_url, formData)

    await axios.post(appConfig.api_base + 'tipsters/nicename', {
      "id": data._id,
      "nicename": response.data.data
    })
  }

  return (
    <>
      {registered &&
        <div className="alert alert-success alert-dismissible fade show">
          <h2>Register</h2>
          <strong>Registration complete.</strong> Please check your email and set your password.
        </div>
      }
      {!registered &&
        <form className="mtr-form" onSubmit={onSubmit}>
          <h2>Register</h2>
          <div className="mb-3">
            <label htmlFor="username" className="form-label">Username</label>
            <input type="username" className="form-control" id="username" name="password" required/>
          </div>
          <div className="mb-3">
            <label htmlFor="email" className="form-label">Email address</label>
            <input type="email" className="form-control" id="email" name="email" required/>
          </div>
          <div className="mb-3 form-check">
            <input type="checkbox" className="form-check-input" id="newsletter"/>
            <label className="form-check-label" htmlFor="newsletter">Subscribe for Newsletters</label>
          </div>
          <button type="submit" className="btn btn-primary" disabled={loading}>
            Submit<Spinner loading={loading}/>
          </button>
          {responseMessage && <div className="text-danger">{responseMessage}</div>}
          <div className="mt-2">
            <Link href="/dashboard/login">Already registered? Login.</Link><br/>
          </div>
        </form>
      }
    </>
  )

};

export default Register
